import { logo } from './logo'
import { marker } from './mapMarker'
import { like } from './like'
import * as icons from '../../services/icons/js/index';
export const iconsSet = { logo,like,marker, ...icons }
